import React from "react";
import ReactPlayer from "react-player";
import Button from "@mui/material/Button";

const Music = () => {
  const tracks = [
    {
      id: 1,
      title: "Prada - Kalekdan Mix.",
      genre: "Drum & Bass / Remix",
      description:
        "A remix of the RAYE song 'Prada', but make it Drum & Bass.",
      url: "https://soundcloud.com/kalekdan/prada",
      year: "2025",
    },
    {
      id: 2,
      title: "Soaring.",
      genre: "Orchestral",
      description:
        "An orchestral piece created to translate the emotion of soaring through the skies.",
      url: "https://soundcloud.com/kalekdan/soaring",
      year: "2022",
    },
    {
      id: 3,
      title: "Elend's Theme.",
      genre: "Fantasy/Orchestral",
      description:
        "A musical theme for a character from Brandon Sanderson's Mistborn series, capturing their essence and journey.",
      url: "https://soundcloud.com/kalekdan/elends_theme",
      year: "2021",
    },
    {
      id: 4,
      title: "Neon Wave.",
      genre: "Drum & Bass",
      description:
        "Drum & Bass featuring samples from Back to the Future, blending retro sci-fi with modern beats.",
      url: "https://soundcloud.com/kalekdan/neon-wave",
      year: "2023",
    },
    {
      id: 5,
      title: "A Chance Encounter.",
      genre: "Ballad/Romantic",
      description:
        "A rom-com inspired track perfect for meet-cute scenes and romantic moments. Uplifting and playful.",
      url: "https://soundcloud.com/kalekdan/a-chance-encounter",
      year: "2023",
    },
    {
      id: 6,
      title: "Forgotten Memories.",
      genre: "Ballad/Romantic",
      description:
        "A melancholic piano ballad, harking to lost childhood and fading memories.",
      url: "https://soundcloud.com/kalekdan/forgotten-memories",
      year: "2023",
    },    
  ];

  return (
    <>
      <div className="title">
        <h2 className="heading">sound & vibe.</h2>
        <p className="section-subtitle">Electronic, orchestral, and everything in between</p>
      </div>
      <div className="music-intro">
        <p>
          Classically trained on piano and cornet, I've been playing and making music since I
          could walk. Under the artist name <strong>Kalekdan</strong>, I produce electronic music
          across multiple genres.
        </p>
        <p>
          My work spans from orchestral scores for games and film, to electronic genres like lofi
          hip-hop and drum & bass. Who knows what genre I'll make next (hint. not me).
        </p>
        <Button
          href="https://soundcloud.com/kalekdan"
          target="_blank"
          rel="noreferrer"
          variant="contained"
          sx={{
            backgroundColor: "var(--primary-color2)",
            color: "white",
            mt: 2,
            "&:hover": {
              backgroundColor: "var(--primary-color3)",
            },
          }}
        >
          Listen on SoundCloud
        </Button>
      </div>

      <div className="music-content">
        <div className="music-header">
          <h2>Featured Tracks</h2>
        </div>

        <div className="tracks-grid">
          {tracks.map((track) => (
            <div key={track.id} className="music-track">
              <div className="track-header">
                <h3>{track.title}</h3>
                <span className="track-genre">{track.genre}</span>
              </div>

              <p className="track-description">{track.description}</p>

              <div className="track-player">
                <ReactPlayer
                  url={track.url}
                  width="100%"
                  height="100px"
                  controls
                  light={false}
                />
              </div>

              <div className="track-meta">
                <span>Year: {track.year}</span>
              </div>

              <Button
                href={track.url}
                target="_blank"
                rel="noreferrer"
                variant="outlined"
                size="small"
                sx={{
                  borderColor: "var(--primary-color2)",
                  color: "var(--primary-color2)",
                  mt: 1,
                  "&:hover": {
                    backgroundColor: "rgba(191, 99, 48, 0.1)",
                  },
                }}
              >
                View on SoundCloud
              </Button>
            </div>
          ))}
        </div>

        <div className="music-cta">
          <h3>Want more?</h3>
          <p>Check out all my music and remixes on SoundCloud</p>
          <Button
            href="https://soundcloud.com/kalekdan"
            target="_blank"
            rel="noreferrer"
            variant="contained"
            sx={{
              backgroundColor: "var(--primary-color2)",
              color: "white",
              "&:hover": {
                backgroundColor: "var(--primary-color3)",
              },
            }}
          >
            Explore Full Catalogue
          </Button>
        </div>
      </div>
    </>
  );
};

export default Music;
